import { RectangularLoader } from "../../molecules/skeleton-loader/RectangularLoader";

export const RunnableDetailsLoader = () => {
  return <RectangularLoader height="100vh" width="100vw" />;
};
